import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { $themeConfig } from '../../theme.config';
import { TranslateService } from '@ngx-translate/core';
import { translateFileLang } from '../../shared/utils/translate-file-lang';

@Injectable()
export class AppService {
    storeData!: StoreData;
    constructor(
        public translate: TranslateService,
        public store: Store<{ index: StoreData }>,
    ) {
        this.initStoreData();
    }

    initStoreData() {
        this.store.select((d) => d.index).subscribe((d) => {
            this.storeData = d;
        });

        // set default styles
        let val: string | null = localStorage.getItem('theme'); // light, dark, system
        val = val || $themeConfig.theme;
        this.store.dispatch({ type: 'toggleTheme', payload: val });

        val = localStorage.getItem('menu'); // vertical, collapsible-vertical, horizontal
        val = val || $themeConfig.menu;
        this.store.dispatch({ type: 'toggleMenu', payload: val });

        val = localStorage.getItem('layout'); // full, boxed-layout
        val = val || $themeConfig.layout;
        this.store.dispatch({ type: 'toggleLayout', payload: val });

        val = localStorage.getItem('i18n_locale'); // en, da, de, el, es, fr, hu, it, ja, pl, pt, ru, sv, tr, zh
        val = val || $themeConfig.locale;
        if (val === 'ar') {
            localStorage.setItem('i18n_locale', 'sa');
            val = 'sa';
        }

        const list = this.storeData.languageList;
        const item = list.find((item) => item.code === val);
        if (item) {
            this.toggleLanguage(item);
        }

        val = localStorage.getItem('rtlClass'); // rtl, ltr
        val = val || $themeConfig.rtlClass;
        this.store.dispatch({ type: 'toggleRTL', payload: val });

        val = localStorage.getItem('animation'); // animate__fadeIn, animate__fadeInDown, animate__fadeInUp, animate__fadeInLeft, animate__fadeInRight, animate__slideInDown, animate__slideInLeft, animate__slideInRight, animate__zoomIn
        val = val || $themeConfig.animation;
        this.store.dispatch({ type: 'toggleAnimation', payload: val });

        val = localStorage.getItem('navbar'); // navbar-sticky, navbar-floating, navbar-static
        val = val || $themeConfig.navbar;
        this.store.dispatch({ type: 'toggleNavbar', payload: val });

        const semidarkValue = localStorage.getItem('semidark');
        const semidark = semidarkValue === 'true' ? true : $themeConfig.semidark;
        this.store.dispatch({ type: 'toggleSemidark', payload: semidark });
    }

    toggleLanguage(item: LanguageItem | null) {
        let lang: LanguageItem | null = item;
        if (!lang) {
            let code: string | null = this.translate.getCurrentLang() || null;
            if (!code) {
                code = localStorage.getItem('i18n_locale');
            }
            const listCode = translateFileLang(code);

            lang = this.storeData.languageList.find((d) => d.code === listCode) || null;
        }

        if (!lang) {
            lang = this.storeData.languageList.find((d) => d.code === 'en') || null;
        }

        if (lang) {
            this.translate.use(translateFileLang(lang.code)); // set language (sa.json for Arabic)
            document.documentElement.lang = lang.code === 'sa' ? 'ar' : lang.code;
            this.store.dispatch({ type: 'toggleLocale', payload: lang.code });
        }
        return lang;
    }

    changeAnimation(type: 'add' | 'remove' = 'add') {
        if (this.storeData.animation) {
            const ele: any = document.querySelector('.animation');
            if (type === 'add') {
                ele?.classList.add('animate__animated');
                ele?.classList.add(this.storeData.animation);
            } else {
                ele?.classList.remove('animate__animated');
                ele?.classList.remove(this.storeData.animation);
            }
        }
    }
}

interface LanguageItem {
    code: string;
    [key: string]: unknown;
}

interface StoreData {
    languageList: LanguageItem[];
    animation?: string;
    [key: string]: unknown;
}
